import React from "react";
import Heading from "../Heading/Heading";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaRedditAlien,
  FaGithub,
} from "react-icons/fa";
import "./contact.css";

const Contact = () => {
  return (
    <section id="contact" className="mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Heading title1="Contact" title2="Contact Me" />
          </div>
          <div className="col-lg-6 col-md-6 mt-4">
            <div className="contact-summary">
              <p className="text-5 lh-2">
                I am interested in working with any company that thinks my skill
                will be helpful for them. If you are looking for someone like
                me, please let me know. Or you can just 'say hi' to me.
              </p>
              <div className="sm-center">
                <a
                  className="contact-btn mt-4"
                  href="mailto:nazmulhasannannu74@gmail.com"
                >
                  Contact Me
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 mt-4">
            <div className="contact-details">
              <ul>
                <li>
                  <h5 className="fw-bold">Email</h5>
                  <p>nazmulhasannannu74@gmail</p>
                </li>
                <li>
                  <h5 className="fw-bold">Skype</h5>
                  <p>nazmulnannu43_1</p>
                </li>
                <li>
                  <h5 className="fw-bold">Social</h5>
                  <ul className="social-link">
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://github.com/nannu-coder"
                      >
                        <FaGithub size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.facebook.com/nannu.hasan.32/"
                      >
                        <FaFacebookF size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.instagram.com/nazmul_nannu/"
                      >
                        <FaInstagram size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.linkedin.com/in/nazmulnannu/"
                      >
                        <FaLinkedinIn size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://twitter.com/NannuHasan32"
                      >
                        <FaTwitter size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.reddit.com/user/nazmul_nannu"
                      >
                        <FaRedditAlien size={22} />
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
